import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { TranslatorPipe } from '../services/translator.pipe';
import { link, breadcrumb, stat } from '../admin/layout/header/header.component';
import { DataService } from '../services/data.service';
import { MessageService, ConfirmationService, MenuItem } from 'primeng/api';
import { PermissionHandlerService } from '../services/permission-handler.service';
import { GlobalConstants } from '../services/global-constants';
import { cloneDeep } from 'lodash';
import { QuestionBase } from '../misc/component/dynamic-form/question-base';
import { TextboxQuestion } from '../misc/component/dynamic-form/question-textbox';
import { DropdownQuestion } from '../misc/component/dynamic-form/question-dropdown';
import { TextEditorQuestion } from '../misc/component/dynamic-form/question-editor';
import { TimePickerQuestion } from '../misc/component/dynamic-form/question-timepicker';
import { RadioButtonQuestion } from '../misc/component/dynamic-form/question-radiobutton';
import { DynamicFormComponent } from '../misc/component/dynamic-form/dynamic-form.component';
import moment from 'moment-timezone';
import { OrgUnitsService } from '../services/org-units.service';
import { CheckBoxQuestion } from '../misc/component/dynamic-form/question-checkbox';

@Component({
  selector: 'app-permission-requests',
  templateUrl: './permission-requests.component.html',
  styleUrl: './permission-requests.component.scss',
  providers: [MessageService, ConfirmationService]
})
export class PermissionRequestsComponent implements OnInit {
  header = this.translate('Permission Requests');
  links: link[] = [];
  breadcrumbs: breadcrumb[] = [ { name: this.translate('Permission Requests'), link: '/permission/requests' },];
  stats: stat[] = [];
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  noRequest: boolean = true;
  requestForm: boolean = false;
  loading: boolean = false;
  
  
  dateRange: any;
  permissions: any[] = [];
  currentPage: number = 1;
  rows: number = 10;    
  first: number = 0;
  totalCount: number = 0;

 
  ouFilter: any;
  managerFilter: any;
  statusFilter: any;
  treeData: any[] = [];
  selectedTreeData_orginal: any;
  selectedTreeData: any;
  selectedTreeTags_current: any;
  contentUpdateUsers: any;

  filterForm: FormGroup<{
    typeFlag: FormControl<string | null>;
    dateRange: FormControl<Date[] | null>;
  }>;

 
  expandedPermissions: Set<string> = new Set();
  selectedPermissionId: string | null = null;
  isViewing: boolean = false;  
  isLoading = true;  

  // Assessment and Survey related properties
  menuItems: MenuItem[] = [
    {
      label: '<span class="mx-3">تعديل</span>',
      escape: false,
      icon: 'pi pi-refresh',
      command: () => {
        this.permissionActionCall({ id: this.operationPermission._id, action: 'Update' })
      }
    },
    {
      label: '<span class="mx-3">عرض النتائج</span>',
      escape: false,
      icon: 'pi pi-chart-bar',
      command: () => {
        this.permissionActionCall({ id: this.operationPermission._id, action: 'ViewResults' })
      }
    }
  ];

  operationPermission: any;

  // Update modal properties
  updateModal = false;
  updateData: any;
  updateQuestions: QuestionBase<string>[] = [];
  messages: any[] = [];
  modalKey: number = 0; // Unique key to force component recreation

  @ViewChild('dynamicForm') dynamicForm!: DynamicFormComponent;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private messageService: MessageService,
    private permissionService: PermissionHandlerService,
    private confirmationService: ConfirmationService,
    private ouService: OrgUnitsService
  ) {
    this.filterForm = this.fb.group({
      typeFlag: new FormControl<string | null>(null),
      dateRange: new FormControl<Date[] | null>(null)
    });
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  ngOnInit() {
    Promise.all([
      this.getTreeData(),
      this.fetchUsers()
    ]).then(() => {
      this.getPermissions();
    });
  }

  onPageChange(event: any) {
    this.currentPage = event.first / this.rows + 1;
    this.rows = event.rows;
    this.getPermissions();
  }

  async fetchUsers(): Promise<void> {
    let res = await this.dataService.getData('content-update/users');
    if (res.error) {
      return;
    }

    this.contentUpdateUsers = res.data[0];
    this.contentUpdateUsers.approved_by = this.contentUpdateUsers.approved_by.map((user:any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });
    this.contentUpdateUsers.updated_by = this.contentUpdateUsers.updated_by.map((user:any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });

    this.contentUpdateUsers = new Set([...this.contentUpdateUsers.approved_by, ...this.contentUpdateUsers.updated_by]);
  }

  flattenTree(root: any[]): any[] {
    const result: any[] = [];
    root?.map(e => this.flattenNode(e, result));
    return result;
  }

  private flattenNode(node: any, result: any[]): void {
    result.push((node as any)?._id);
    if(node?.children){
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }

  getFilterQuery() {
    let query: any = {};
    if (this.ouFilter) {
      let newOuArray = [this.ouFilter];
      query['ou'] = this.flattenTree(newOuArray);
    }
    if (this.managerFilter) {
      query['manager._id'] = this.managerFilter._id;
    }
    if (this.statusFilter) {
      query['status'] = this.statusFilter.value.e;
    }
    if (this.dateRange) {
      query['permissionFrom'] = this.dateRange[0];
      query['permissionTo'] = this.dateRange[1];
    }
    if (this.filterForm.get('typeFlag')?.value) {
      query['type'] = this.filterForm.get('typeFlag')?.value;
    }
    return query;
  }

  hasPermissionRequest() {
    const permissionRequests = JSON.parse(localStorage.getItem('permissionRequests') || '[]');
    return (permissionRequests && permissionRequests.length > 0) ||  this.permissionService.hasPermission('PERMISSION_REQUESTS', 'r');
  }

  async getPermissions() {
    this.isLoading = true;  
    try {
      let query = this.getFilterQuery();

      

      query.page = this.currentPage;
      query.offset = this.rows

      const isTester = localStorage.getItem('isTester')
      if(!this.hasPermission('PERMISSION_REQUESTS','r') && !this.hasPermissionRequest() && isTester){
       query.email = localStorage.getItem('email');
      }

      if(!this.hasPermission('PERMISSION_REQUESTS','r') && this.hasPermissionRequest()){
        query.email = localStorage.getItem('email');
      }

      ;

      const response = await this.dataService.postData('permission-request/get', query);

      if (!response.error) {
        this.permissions = response?.data[0].data;
        this.totalCount = response?.data[0].metadata[0].totalCount;
        this.noRequest = this.permissions.length === 0;
     } else {
        console.error('No permissions found', response.error);
        this.permissions = [];
        this.totalCount = 0; 
        
        this.noRequest = true;
        this.messageService.add({
          severity: 'error',
          summary: this.translate('Error'),
          detail: this.translate('No permissions found')
        });
      }
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate('Error'),
        detail: this.translate('Error fetching permissions')
      });
      this.permissions = [];
      this.totalCount = 0;
      this.noRequest = true;
    } finally {
      this.isLoading = false;  
    }
  }

  clearFilters() {
    this.ouFilter = null;
    this.managerFilter = null;
    this.statusFilter = null;
    this.dateRange = null;
    this.filterForm.reset();
    this.getPermissions();
  }

  hasPermission(key: string, flag: string) {
    return this.permissionService.hasPermission(key, flag);
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }


  async getTreeData() {
    this.treeData = await this.ouService.getOrgUnits();
    
    this.selectedTreeData_orginal = cloneDeep(this.treeData)
    this.changeSelectedTag(null);
    console.log("===>test data d",this.selectedTreeData);
  }

  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Ministries/Entities"
    };
    if (this.selectedTreeTags_current.label) {
      console.log("change tag event1", event,this.selectedTreeData);
      await this.filterTreeByTag("Ministries/Entities");
    } else {
      this.selectedTreeData = null;
    }
  }

  filterTreeByTag(tag: string) {
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);
      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }
    return null;
  }

 
  togglePermissionDetails(permissionId: string) {
    if (this.expandedPermissions.has(permissionId)) {
      this.expandedPermissions.delete(permissionId);
    } else {
      this.expandedPermissions.add(permissionId);
    }
  }

 
  isPermissionExpanded(permissionId: string): boolean {
    return this.expandedPermissions.has(permissionId);
  }

 
  getMinMaxDates(testEntries: any[]): { minDate: string, maxDate: string } {
    if (!testEntries || testEntries.length === 0) {
      return { minDate: '', maxDate: '' };
    }

    const dates = testEntries.map(entry => new Date(entry.testDate).getTime());
    const minDate = new Date(Math.min(...dates));
    const maxDate = new Date(Math.max(...dates));

    return {
      minDate: minDate.toISOString().split('T')[0],
      maxDate: maxDate.toISOString().split('T')[0]
    };
  }

  openPermissionForm(permissionId: string) {
    this.selectedPermissionId = permissionId;
    this.requestForm = true;
    this.isViewing = true;  
  }

  // When creating new permission
  createNewPermission() {
    this.selectedPermissionId = null;
    this.requestForm = true;
    this.isViewing = false; 
  }

  // Open permission menu for actions
  openPermissionMenu(menu: any, event: any, permission: any, itemInfo?: any) {
    this.operationPermission = permission;
    this.operationPermission.itemInfo = itemInfo; // Store the specific item info
    menu.toggle(event);
  }

  // Handle permission actions
  permissionActionCall($event: any) {
    switch ($event.action) {
      case 'Update':
        // Check if we have specific item info
        if (this.operationPermission.itemInfo) {
          const itemInfo = this.operationPermission.itemInfo;
          if (itemInfo.assessmentId) {
            this.updateAssessment(itemInfo.assessmentId);
          } else if (itemInfo.surveyId) {
            this.updateSurvey(itemInfo.surveyId);
          } else if (itemInfo.testId) {
            // For testEntries, we need to find the specific test
            const testEntry = this.operationPermission.testEntries.find((test: any) => test._id === itemInfo.testId);
            if (testEntry) {
              if (testEntry.assessmentId) {
                this.updateAssessment(testEntry.assessmentId);
              } else if (testEntry.surveyId) {
                this.updateSurvey(testEntry.surveyId);
              }
            }
          }
        } else {
          // Fallback to original logic for backward compatibility
          if (this.operationPermission.status === 'APPROVED') {
            // For approved requests, check assessments and surveys
            if (this.operationPermission.assessments && this.operationPermission.assessments.length > 0) {
              this.updateAssessment(this.operationPermission.assessments[0]._id);
            } else if (this.operationPermission.surveys && this.operationPermission.surveys.length > 0) {
              this.updateSurvey(this.operationPermission.surveys[0]._id);
            }
          } else {
            // For non-approved requests, use testEntries
            if (this.operationPermission.testEntries && this.operationPermission.testEntries.length > 0) {
              const testEntry = this.operationPermission.testEntries[0]; // Get first test entry
              if (testEntry.assessmentId) {
                this.updateAssessment(testEntry.assessmentId);
              } else if (testEntry.surveyId) {
                this.updateSurvey(testEntry.surveyId);
              }
            }
          }
        }
        break;
      case 'ViewResults':
        // Check if we have specific item info
        if (this.operationPermission.itemInfo) {
          const itemInfo = this.operationPermission.itemInfo;
          if (itemInfo.assessmentId) {
            this.openAssessmentResults(itemInfo.assessmentId, this.operationPermission._id);
          } else if (itemInfo.surveyId) {
            this.openSurveyResults(itemInfo.surveyId, this.operationPermission._id);
          } else if (itemInfo.testId) {
            // For testEntries, we need to find the specific test
            const testEntry = this.operationPermission.testEntries.find((test: any) => test._id === itemInfo.testId);
            if (testEntry) {
              if (testEntry.assessmentId) {
                this.openAssessmentResults(testEntry.assessmentId, this.operationPermission._id);
              } else if (testEntry.surveyId) {
                this.openSurveyResults(testEntry.surveyId, this.operationPermission._id);
              }
            }
          }
        } else {
          // Fallback to original logic for backward compatibility
          if (this.operationPermission.status === 'APPROVED') {
            // For approved requests, check assessments and surveys
            if (this.operationPermission.assessments && this.operationPermission.assessments.length > 0) {
              this.openAssessmentResults(this.operationPermission.assessments[0]._id, this.operationPermission._id);
            } else if (this.operationPermission.surveys && this.operationPermission.surveys.length > 0) {
              this.openSurveyResults(this.operationPermission.surveys[0]._id, this.operationPermission._id);
            }
          } else {
            // For non-approved requests, use testEntries
            if (this.operationPermission.testEntries && this.operationPermission.testEntries.length > 0) {
              const testEntry = this.operationPermission.testEntries[0]; // Get first test entry
              if (testEntry.assessmentId) {
                this.openAssessmentResults(testEntry.assessmentId, this.operationPermission._id);
              } else if (testEntry.surveyId) {
                this.openSurveyResults(testEntry.surveyId, this.operationPermission._id);
              }
            }
          }
        }
        break;
      case 'Delete':
        this.deletePermission($event.id);
        break;
      default:
        console.log('Unknown action');
        break;
    }
  }

  // Update assessment details
  async updateAssessment(assessmentId: string) {
    try {
      // Clear previous data first
      this.updateData = undefined;
      this.updateQuestions = [];
      this.messages = [];
      this.modalKey++; // Force component recreation
      if (this.dynamicForm) {
        this.dynamicForm.resetForm();
      }
      
      let res = await this.dataService.getData(`assessment/id/${assessmentId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.updateData = res.data;
      this.updateData.testType = 'ASSESSMENT'; // Set type for modal
      this.makeUpdateAssessmentQuestions();
      this.updateModal = true;
    } catch (error) {
      console.log(error);
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Error fetching assessment') },
      ];
    }
  }

  // Update survey details
  async updateSurvey(surveyId: string) {
    try {
      // Clear previous data first
      this.updateData = undefined;
      this.updateQuestions = [];
      this.messages = [];
      this.modalKey++; // Force component recreation
      if (this.dynamicForm) {
        this.dynamicForm.resetForm();
      }
      
      let res = await this.dataService.getData(`survey/id/${surveyId}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.updateData = res.data;
      this.updateData.testType = 'SURVEY'; // Set type for modal
      this.makeUpdateSurveyQuestions();
      this.updateModal = true;
    } catch (error) {
      console.log(error);
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Error fetching survey') },
      ];
    }
  }

  // Create update questions for assessment modal
  makeUpdateAssessmentQuestions() {
    this.updateQuestions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        value: this.updateData?.name,
        className: 'col-12',
      }),

      new TimePickerQuestion({
        key: 'startDate',
        label: this.translate('Start Date'),
        className: 'col-6',
        visibility: "true",
        value: this.updateData?.startDate,
        showTime: false,
        required: true,
        touchUI: true,
        disable: !this.hasPermission('PERMISSION_REQUESTS_APPROVE', 'a')
      }),

      new TimePickerQuestion({
        key: 'endDate',
        label: this.translate('End Date'),
        className: 'col-6',
        visibility: "true",
        value: this.updateData?.endDate,
        showTime: false,
        required: true,
        touchUI: true,
        disable: !this.hasPermission('PERMISSION_REQUESTS_APPROVE', 'a')
      }),

      new DropdownQuestion({
        key: 'status',
        label: this.translate('Status'),
        required: true,
        options: [
          { label: this.translate('Pending'), value: 'Pending' },
          { label: this.translate('Active'), value: 'Active' },
          { label: this.translate('Closed'), value: 'Closed' }
        ],
        className: 'col-12',
        visibility: "true",
        value: this.updateData?.status
      }),

      new TextEditorQuestion({
        key: 'comments',
        label: this.translate('Comments'),
        className: 'col-12',
        visibility: "true",
        value: this.updateData?.comments
      }),

      new RadioButtonQuestion({
        key: 'accessType',
        label: this.translate('Type'),
        required: true,
        options: [
          { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
          { label: this.translate('BY_LINK'), icon: 'pi pi-web', value: 'BY_URL' },
        ],
        className: 'col-12',
        visibility: "true",
        value: this.updateData?.accessType
      }),
    ];
  }

  // Create update questions for survey modal
  makeUpdateSurveyQuestions() {
    this.updateQuestions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('Name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        value: this.updateData?.name,
        className: 'col-12',
      }),

      new TimePickerQuestion({
        key: 'startDate',
        label: this.translate('Start Date'),
        className: 'col-6',
        visibility: "true",
        value: this.updateData?.startDate,
        showTime: false,
        required: true,
        touchUI: true,
        disable: !this.hasPermission('PERMISSION_REQUESTS_APPROVE', 'a')
      }),

      new TimePickerQuestion({
        key: 'endDate',
        label: this.translate('End Date'),
        className: 'col-6',
        visibility: "true",
        value: this.updateData?.endDate,
        showTime: false,
        required: true,
        touchUI: true,
        disable: !this.hasPermission('PERMISSION_REQUESTS_APPROVE', 'a')
      }),

      new DropdownQuestion({
        key: 'status',
        label: this.translate('Status'),
        required: true,
        options: [
          { label: this.translate('Pending'), value: 'Pending' },
          { label: this.translate('Active'), value: 'Active' },
          { label: this.translate('Closed'), value: 'Closed' }
        ],
        className: 'col-12',
        visibility: "true",
        value: this.updateData?.status
      }),

      new TextEditorQuestion({
        key: 'comments',
        label: this.translate('Comments'),
        className: 'col-12',
        visibility: "true",
        value: this.updateData?.comments
      }),

      new RadioButtonQuestion({
        key: 'accessType',
        label: this.translate('Type'),
        required: true,
        options: [
          { label: this.translate('Through Knowledge Portal Users'), icon: 'pi pi-account', value: 'BY_ACCOUNT' },
          { label: this.translate('BY_LINK'), icon: 'pi pi-web', value: 'BY_URL' },
        ],
        className: 'col-12',
        visibility: "true",
        value: this.updateData?.accessType
      }),

      new CheckBoxQuestion({
        key: 'anonymous',
        label: 'إخفاء هوية المشارك',
        required: false,
        order: 1,
        className: 'col-md-6 col-sm-12 col-12',
        value: this.updateData.anonymous || false
      }),
    ];
  }

  // Update assessment data
  updateAssessmentData = async (event: any) => {
    try {
      let data: any = event;
      
      console.log('Assessment update data received:', data);
      console.log('startDate type:', typeof data.startDate, 'value:', data.startDate);
      console.log('endDate type:', typeof data.endDate, 'value:', data.endDate);
      
      // Format dates for assessment (DD-MM-YYYY HH:mm)
      if (data.startDate) {
        // Parse the date with the correct format (DD-MM-YYYY HH:mm:ss or DD-MM-YYYY HH:mm)
        const startMoment = moment(data.startDate, ['DD-MM-YYYY HH:mm:ss', 'DD-MM-YYYY HH:mm'], true);
        if (startMoment.isValid()) {
          data.startDate = startMoment.format('DD-MM-YYYY HH:mm');
        } else {
          console.error('Invalid startDate:', data.startDate);
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: this.translate('Invalid start date format') },
          ];
          return;
        }
      }
      if (data.endDate) {
        // Parse the date with the correct format (DD-MM-YYYY HH:mm:ss or DD-MM-YYYY HH:mm)
        const endMoment = moment(data.endDate, ['DD-MM-YYYY HH:mm:ss', 'DD-MM-YYYY HH:mm'], true);
        if (endMoment.isValid()) {
          data.endDate = endMoment.format('DD-MM-YYYY HH:mm');
        } else {
          console.error('Invalid endDate:', data.endDate);
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: this.translate('Invalid end date format') },
          ];
          return;
        }
      }
      
      console.log('Assessment data after formatting:', data);
      
      // Add the assessment ID for update
      data._id = this.updateData._id;

      let res = await this.dataService.postData(
        'assessment',
        data,
        'PUT',
        false
      );
      
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      
      this.updateModal = false;
      this.updateData = undefined;
      
      // Refresh the permissions list
      this.getPermissions();
    } catch (error) {
      console.log(error);
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Error updating assessment') },
      ];
    }
  };

  // Update survey data
  updateSurveyData = async (event: any) => {
    try {
      let data: any = event;
      
      console.log('Survey update data received:', data);
      console.log('startDate type:', typeof data.startDate, 'value:', data.startDate);
      console.log('endDate type:', typeof data.endDate, 'value:', data.endDate);
      
      // Format dates for survey (DD-MM-YYYY HH:mm:ss)
      if (data.startDate) {
        // Parse the date with the correct format (DD-MM-YYYY HH:mm:ss or DD-MM-YYYY HH:mm)
        const startMoment = moment(data.startDate, ['DD-MM-YYYY HH:mm:ss', 'DD-MM-YYYY HH:mm'], true);
        if (startMoment.isValid()) {
          data.startDate = startMoment.format('DD-MM-YYYY HH:mm:ss');
        } else {
          console.error('Invalid startDate:', data.startDate);
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: this.translate('Invalid start date format') },
          ];
          return;
        }
      }
      if (data.endDate) {
        // Parse the date with the correct format (DD-MM-YYYY HH:mm:ss or DD-MM-YYYY HH:mm)
        const endMoment = moment(data.endDate, ['DD-MM-YYYY HH:mm:ss', 'DD-MM-YYYY HH:mm'], true);
        if (endMoment.isValid()) {
          data.endDate = endMoment.format('DD-MM-YYYY HH:mm:ss');
        } else {
          console.error('Invalid endDate:', data.endDate);
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: this.translate('Invalid end date format') },
          ];
          return;
        }
      }
      
      console.log('Survey data after formatting:', data);
      
      // Add the survey ID for update
      data._id = this.updateData._id;

      let res = await this.dataService.postData(
        'survey',
        data,
        'PUT',
        false
      );
      
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      
      this.updateModal = false;
      this.updateData = undefined;
      
      // Refresh the permissions list
      this.getPermissions();
    } catch (error) {
      console.log(error);
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Error updating survey') },
      ];
    }
  };

  // Update permission data (legacy - keeping for compatibility)
  updatePermissionData = async (event: any) => {
    try {
      let data: any = event;
      
      // Add the permission ID for update
      data._id = this.updateData._id;

      let res = await this.dataService.postData(
        'permission-request',
        data,
        'PUT',
        false
      );
      
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      
      this.updateModal = false;
      this.updateData = undefined;
      
      // Refresh the permissions list
      this.getPermissions();
    } catch (error) {
      console.log(error);
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Error updating permission') },
      ];
    }
  };

  // Close dialog
  onDialogClose() {
    this.updateModal = false;
    this.updateData = undefined;
    this.updateQuestions = [];
    this.messages = [];
    this.modalKey = 0; // Reset key
    if (this.operationPermission) {
      this.operationPermission.itemInfo = undefined; // Clear item info
    }
    if (this.dynamicForm) {
      this.dynamicForm.resetForm();
    }
  }

  navigateToSurvey(test: any, permissionId : string) {
    // For survey results
    if (test.surveyId) {
      this.router.navigate(['/survey/add-question/', test.surveyId], { 
        queryParams: { 
          TypeId: '6838bd5093197086870562ae',
          permission : permissionId

        }
      });
    } 
    // For assessment results
    else if (test.assessmentId) {
      this.router.navigate(['/assessment/add-question/', test.assessmentId], { 
        queryParams: { 
          QBankId: '683c3e6ea785b2b30b07071c',
          tabIndex: 0,
          permission : permissionId
        }
      });
    }
  }

  // Navigate to survey results
  openSurveyResults(surveyId: string, permissionId: string) {
    this.router.navigate(['/survey/results/', surveyId], {
      queryParams: {
        TypeId: '6838bd5093197086870562ae',
        permission: permissionId,
        Main: 1,
        back: 'permission-requests'
      }
    });
  }

  // Navigate to assessment results
  openAssessmentResults(assessmentId: string, permissionId: string) {
    this.router.navigate(['/assessment/results/', assessmentId], {
      queryParams: {
        QBankId: '683c3e6ea785b2b30b07071c',
        tabIndex: 0,
        permission: permissionId,
        Main: 1,
        back: 'permission-requests'
      }
    });
  }

  // Navigate to survey add questions
  openSurveyAddQuestions(surveyId: string, permissionId: string) {
    this.router.navigate(['/survey/add-question/', surveyId], {
      queryParams: {
        TypeId: '6838bd5093197086870562ae',
        permission: permissionId
      }
    });
  }

  // Navigate to assessment add questions
  openAssessmentAddQuestions(assessmentId: string, permissionId: string) {
    this.router.navigate(['/assessment/add-question/', assessmentId], {
      queryParams: {
        QBankId: '683c3e6ea785b2b30b07071c',
        tabIndex: 0,
        permission: permissionId
      }
    });
  }

  deletePermission(permissionId: string) {
    this.confirmationService.confirm({
      message: this.translate('Are you sure you want to delete this permission request?'),
      header: this.translate('Delete Confirmation'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('No'),
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-text',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: async () => {
        try {
          const response = await this.dataService.deleteData(`permission-request/${permissionId}`);
          this.getPermissions();
          if (response.success) {
            this.permissions = this.permissions.filter(p => p._id !== permissionId);
            this.totalCount--;
            this.noRequest = this.permissions.length === 0;

            this.messageService.add({
              severity: 'success',
              summary: this.translate('Success'),
              detail: this.translate(response.message || 'Permission request deleted successfully')
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: this.translate('Error'),
              detail: this.translate(response.message || 'Failed to delete permission request')
            });
          }
        } catch (error: any) {
          if (error.status === 404) {
            this.messageService.add({
              severity: 'error',
              summary: this.translate('Error'),
              detail: this.translate('Permission request not found')
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: this.translate('Error'),
              detail: this.translate(error.message || 'An error occurred while deleting the permission request')
            });
          }
        }
      }
    });
  }

  getTestData(test: any): boolean {
    // For assessment data, check if it has assessmentId and is not null
    if (test?.assessmentId && test.assessmentId !== null) {
      return true;
    }
    // For survey data, check if it has surveyId and is not null
    if (test?.surveyId && test.surveyId !== null) {
      return true;
    }
    return false;
  }

}
